import React from "react";
import "../../../CssFiles/benefitsAndProcess.css";
import process1 from "../../../Images/benefitImages/process1.png";
import process2 from "../../../Images/benefitImages/process2.png";
import process3 from "../../../Images/benefitImages/process3.png";
import process4 from "../../../Images/benefitImages/process4.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ProcessComponent() {
    const sliderSettings = {
        dots: true, 
        infinite: true, 
        speed: 500, 
        slidesToShow: 1, 
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000, 
        arrows:true
    };

    return (
        <div id="process-box">
        <div className="col-6 process-div box1">
            <div className="process-text">HOW IT WORKS?</div>
            <div className="easyWay">
            The <span className="trusted">Easiest Way</span> To Secure Your Loan
            </div>
            <div className="getPerfLoan">
            Getting the perfect loan for your business has never been this easy.
            Follow our simple <span style={{ color: "#00B2A4" }}>4-step</span>{" "}
            process to unlock the funds you need, hassle-free!
            </div>
            <div className="appNow" onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' });}}>Apply Now</div>
        </div>
        <div className="col-6 process-div box2">
            <Slider {...sliderSettings}>
            <div id="process1" className="processImageBox">
                <img src={process1} alt="process1" className="processBoxImg" />
                <div className="boxWithNo">
                <div className="number">1</div>
                <div className="headingProcessBox">
                    <div className="boxHeadingProcess">
                    Apply for loan in a few clicks.
                    </div>
                    <div className="boxTextProcess">
                    Complete our simple 4-step journey by filling your information and uploading relevant documents.
                    </div>
                </div>
                </div>
            </div>
            <div id="process2" className="processImageBox">
                <img src={process2} alt="process2" className="processBoxImg" />
                <div className="boxWithNo">
                <div className="number">2</div>
                <div className="headingProcessBox">
                    <div className="boxHeadingProcess">Get the loan approval</div>
                    <div className="boxTextProcess">
                    We work with you and our partner lenders to get you the best possible loan offer for your needs.
                    </div>
                </div>
                </div>
            </div>
            <div id="process3" className="processImageBox">
                <img src={process3} alt="process3" className="processBoxImg" />
                <div className="boxWithNo">
                <div className="number">3</div>
                <div className="headingProcessBox">
                    <div className="boxHeadingProcess">
                    Complete the verification process
                    </div>
                    <div className="boxTextProcess">
                    Once the loan is approved, get your documents and business verified by the lender’s representatives over call/field visit.
                    </div>
                </div>
                </div>
            </div>
            <div id="process4" className="processImageBox">
                <img src={process4} alt="process4" className="processBoxImg" />
                <div className="boxWithNo">
                <div className="number">4</div>
                <div className="headingProcessBox">
                    <div className="boxHeadingProcess">Get the Loan disbursal</div>
                    <div className="boxTextProcess">
                    The funds are credited in your account for you to expand your business.
                    </div>
                </div>
                </div>
            </div>
            </Slider>
        </div>
        </div>
    );
}
